// 政策快讯
export default [
	{
		path: '/policy',
		name: 'Policy',
		component: () => import('@/views/policy/index'),
		meta: { title: '政策快讯', whiteListed: true }
	}
]
